import { useState, useRef, useEffect } from "react";
import classNames from "classnames";

import { AppHeader } from "../../components/header/header";
import { LoadingIndicator } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import { PillInputBox } from "../../components/forms/form-inputs";
import { AppAlert } from "../../components/utilities/app-alert";
import { useLesson } from "../../services/lessons/lessons.context";
import "../../styles/eval.css";
import { PillDropdown } from "../../components/forms/dropdown-select";
import { useLocation } from "react-router-dom";
import { formatUrl } from "../../_helpers/parseurl";
import { AppFooter } from "../../components/footer/footer";

export const EvalAddPage = () => {

    const { isLoading, token } = useAuth();
    const { loading, addEvalQuestion, getEvalQuestions } = useLesson();

    const [evalData, setEvalData] = useState();
    const [onAlert, setOnAlert] = useState();
    const [filePrev, setFilePrev] = useState();
    const [optionsArr, setOptionsArr] = useState(['','','','']);
    const [valid, setValid] = useState(false);
    const [eQuestions, setEQuestions] = useState([]);

    const letterOpttions = ['A', 'B', 'C', 'D'];

    const {id} = useLocation().state;

    const fileRef = useRef();

     const handleSetValue = (e) => {
        setEvalData((data) => ({
            ...data,
            [e.target.name]: e.target.value
        }))
    }

    const uploadFile = (e) => {
        if (e.target.files[0].type.split("/")[0].toLowerCase() !== "image") {
            setOnAlert({
                caption: "Error!",
                message: "Invalid file format! Please upload a file of type image",
                accept: "Ok",
                onAccept: () => setOnAlert()
            })
            return;
        }
        setFilePrev(URL.createObjectURL(e.target.files[0]));
        setEvalData((d) => ({...d, documentFile: e.target.files[0]}));
    }


   
    const handleSubmit = async (e) => {
        e.preventDefault();
        const resp = await addEvalQuestion(id,evalData, token);
        setOnAlert({
            caption: "Success!",
            message: resp.message,
            accept: "Ok",
            onAccept: () => {
                setOnAlert()
                window.location.reload();
            }
        })
    }

    useEffect(() => {
        (async() => {
            const res = await getEvalQuestions(id);
            setEQuestions(res?.questions);
        })();
        
    }, [id])



    return (
        <div className="min-v">
            <AppHeader />
            {(isLoading || loading) && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAccept={onAlert.onAccept}
                    closeAlert={() => setOnAlert()}
                />
            )}
            <div className="flx-cnt-pg">
                <div className={classNames("cap","lg-txt")}>Add a question</div>
                <div className="sm-sp" />
                <div className={classNames("flx-rw","eval-add-box")}>
                <form className="add-form" onSubmit={(e) => handleSubmit(e)}>
                    <PillInputBox
                        type={"text"}
                        name={"question"}
                        caption={"Question"}
                        onChange={(e) => handleSetValue(e) }
                        placeholder={"Type the question"}
                    />
                    <div className="option-cap">Add answer Options</div>
                    {letterOpttions.map((opt,indx) => (
                        <PillInputBox
                            type={"text"}
                            name={"instructor"}
                            caption={opt}
                            onChange={(e) => {
                                let tmp = optionsArr;
                                tmp[indx] = e.target.value;
                                setOptionsArr(tmp);
                            } }
                            key={indx}
                        />
                    ))}
                    <div className="opt-btn-box">
                        <button 
                            className="cfrm-opt"
                            onClick={(e) => {
                                e.preventDefault();
                                const emptyOpt = optionsArr.some((el) => el === '');
                                if (emptyOpt){
                                    alert("Please fill all options");
                                    return;
                                }
                                setEvalData((d) => ({...d, options: optionsArr}));
                                setValid(true);
                            }}
                        >
                            Confirm answers
                        </button>
                    </div>
                    {filePrev && (
                        <div className="video-prev-box">
                            < img src={filePrev} width={250} alt="" />
                        </div>
                    )}
                    <button 
                        className="sel-click"
                        onClick={(e) => {
                            e.preventDefault();
                            fileRef.current.click();
                        }}
                    > 
                        Add an image (if necessary)
                    </button>
                    <input 
                        type="file" 
                        name="avatar"  
                        onChange={(e) => uploadFile(e)}
                        className="file-sel"
                        ref={fileRef}
                    />
                    <PillDropdown
                        placeholder={"Selected correct option"}
                        data={letterOpttions}
                        onChange={(e) => handleSetValue(e)}
                        name={'answer'}
                    />
                    
                    <button 
                        className={
                            classNames(
                                "form-button",
                                'pill-input-box',
                                {"inactive": !valid }
                            )
                        }
                        disabled={!valid}
                    >
                        Submit
                    </button>
                </form>
                <div className="questions-prev">
                        {eQuestions?.map((q, i) => {
                            return (
                                <div className="question-unit" key={i}>
                                   <div className="question-main">
                                        <div className="q-num">{i+1}</div>
                                        <div className="q-text">{q.question}</div>
                                   </div>
                                   {q.image && (
                                      <img alt="" src={formatUrl(q.image)} className="q-pic"/>
                                   )}
                                   {q.options?.map((opt,k) => (
                                    <div className="opt-unit" key={k}>
                                        <span className="opt-lettr">{letterOpttions[k]}</span>
                                        <span className="opt-text">{opt}</span>
                                    </div>
                                   ))}
                                   <hr/>
                                </div>
                            )
                        })}
                </div>
                </div>
            </div>
            <AppFooter />
        </div>
    )
}